export class Token {
    type;
    offset;
    text;
    constructor(offset, text) {
        this.type = this.constructor.name;
        this.offset = offset;
        this.text = text;
    }
}
//# sourceMappingURL=types.js.map